import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9.75 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V18C4.75 18.6904 5.30964 19.25 6 19.25H9.75M9.75 4.75H18C18.6904 4.75 19.25 5.30964 19.25 6V18C19.25 18.6904 18.6904 19.25 18 19.25H9.75M9.75 4.75V19.25" vectorEffect="non-scaling-stroke" />
		<Path d="M16.6213 14.1213L14.5 12M12.3787 9.87868L14.5 12M14.5 12L16.6213 9.87868M14.5 12L12.3787 14.1213" vectorEffect="non-scaling-stroke" />
	</SVG>
);
